<template>
<!--  内容发布-->
  <div id="ContentRelease">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
<!--            <span>ID</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" type="text" v-model="postData.msgPublishId" placeholder="ID"> -->
            <input @keyup.enter="getList(1)" class="allInput" type="text" v-model="postData.pusher" placeholder="创建人">
          </p>
          <p>
<!--            <span>名称</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" type="text" v-model="postData.contentTitle" placeholder="名称"> -->
            <cander v-model="postData.start" :className="'allInput'" placeholderName="开始时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <cander v-model="postData.end" :minDate="postData.start" :className="'allInput'" placeholderName="结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="pushStatusList" :needReturn="'id'" :placeholder="'状态'" :matchValue="'typeName'" :showValue="'{{typeName}}'" v-model="postData.pushStatus">
              </allSelect>
            </abbr>
          </p>
          <!-- <p> -->
<!--            <span>内容分类</span>-->
            <!-- <abbr class="d_i">
              <allSelect :chooseData="allcontent" :needReturn="'id'" :placeholder="'请选择内容分类（可多选）'" :matchValue="'typeName'" :showValue="'{{typeName}}'" :multiple="true" v-model="postData.ContentTypeIds">
              </allSelect>
            </abbr>
          </p>
          <p> -->
<!--            <span>状态</span>-->
            <!-- <abbr class="d_i">
              <allSelect :chooseData="messageStateList" :needReturn="'id'" :placeholder="'请选择状态（可多选）'" :matchValue="'name'" :showValue="'{{name}}'" :multiple="true" v-model="postData.messageStates">
              </allSelect>
            </abbr>
          </p> -->
          <!-- <p v-if="onSearch"> -->
<!--            <span>创建人</span>-->
            <!-- <input @keyup.enter="getList(1)" placeholder="创建人" class="allInput" type="text" v-model="postData.contentCreatorUser">
          </p> -->
          <!-- <p v-if="onSearch"> -->
<!--            <span class="d_i">更新时间</span>-->
            <!-- <cander v-model="postData.startMsgPublishModifiedTime" :className="'allInput'" placeholderName="更新开始时间"  class="d_i" style="vertical-align: middle"></cander>
            <abbr class="d_i">-</abbr>
            <cander :minDate="postData.startMsgPublishModifiedTime" v-model="postData.endMsgPublishModifiedTime" :className="'allInput'" placeholderName="更新结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p> -->
          <button @click="getList(1)" class="redButtonTwo">搜索</button>
        </div>
        <div style="width: auto">
          <!-- <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span> -->
          <!-- <button @click="getList(1)" class="redButton">
            <i class="icon iconfont iconsousuo"></i>
            <span>搜索</span></button> -->
          <!-- <button @click="clearModel" class="cancelButtonTwo m_r_10">清空</button> -->
          <button class="redButtonTwo" @click="editToUrl()" >新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <!-- <nav class="t_r m_b_10"><button class="redButtonTwo" @click="editToUrl()" v-if="nowApp.roles.indexOf('ContentEditor') >= 0">新建</button></nav> -->
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th class="t_c" width="20px"></th>
            <th>ID</th>
            <!-- <th>名称</th> -->
            <th class="t_c">推送类别</th>
            <!-- <th class="t_c">内容分类</th> -->
<!--            <th class="t_c">推送类别</th>-->
<!--            <th class="t_c">推送方式类型</th>-->
<!--            <th class="t_c">计划推送时间</th>-->
            <th class="t_c">推送时间</th>
            <th class="t_c">推送状态</th>
            <th class="t_c">创建人</th>
            <th class="t_c">创建时间</th>
            <!-- <th>状态</th> -->
            <th class="t_c">推送详情</th>
            <th class="t_c">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td class="t_c" width="2%"><i v-if="item.isApprovalPending" class="dote"></i></td>
            <!-- <td width="6%">{{totalCount - ((index + 1) + (10 * (postData.PageIndex - 1))) + 1}}</td> -->
            <td width="6%">{{item.id}}</td>
            <td width="15%" class="t_c">{{item.pushtype}}</td>
            <td class="t_c" width="15%">{{item.pushPlanTime}}</td>
            <td width="10%" class="t_c">{{item.pushStatus}}</td>
            <td width="13%" class="t_c">{{item.createName}}</td>
            <td class="t_c" width="15%">{{item.creationTime}}</td>
            <!-- <td :class="item.isApprovalPending ? 'colorRed' : ''" width="15%">{{item.messageStateDesc}}</td> -->
            <td class="t_c" width="10%" style="max-width: 150px;">
              <div style="width: 150px;">成功数量：{{item.pushSuccessCount}}</div>
              <div style="width: 150px;">失败数量：{{item.pushErrorCount}}</div>
              <div style="width: 150px;word-break: break-all;white-space: break-spaces;">失败原因：{{item.errorMsg}}</div>
            </td>
            <td class="t_c" width="14%">
              <div v-if="item.pushStatus === '待推送'" class="icon more iconfont icongengduo moreOperations">
                <ul>
                  <li @click="todetail(item)">编辑</li>
                  <li @click="deletePush(item)">删除</li>
                </ul>
              </div>
              <div v-if="item.pushStatus === '审核失败'" class="icon more iconfont icongengduo moreOperations">
                <ul>
                  <li @click="deletePush(item)">删除</li>
                </ul>
              </div>
              <div v-if="item.pushStatus === '审核中' && isAdmin === 'true'" class="icon more iconfont icongengduo moreOperations">
                <ul>
                  <li @click="successList(item)">审核通过</li>
                  <li @click="failList(item)">审核失败</li>
                </ul>
              </div>
              <div v-if="item.pushStatus === '已推送'" class="icon more iconfont icongengduo moreOperations">
                <ul>
                  <li @click="todetail(item)">查看</li>
                  <!-- tip 信息安全原因，不能直接导出hcp -->
                  <!-- <li @click="exportPushPeople(item.id)">导出接收人</li> -->
                </ul>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!--内容列表-新建内容-->
    <model v-if="newModel" :buttonType="0" :title="'新建推送'" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div class="t_c" style="margin-top: 30px;margin-bottom: 20px;height: 200px">
        <span><i class="colorRed m_r_5">*</i><abbr>推送类别：</abbr></span>
        <abbr style="width: 150px" class="d_i">
          <allSelect :chooseData="pushTypeList" :needReturn="'pushType'" :placeholder="'请选择推送类别'" :matchValue="'name'" :showValue="'{{name}}'" v-model="addnewContentType">
          </allSelect>
        </abbr>
      </div>
    </model>

    <model v-if="newModel2" :buttonType="0" :title="'审核失败'" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel2()">
      <div class="t_c" style="margin-top: 30px;margin-bottom: 20px;height: 200px">
        <span><i class="colorRed m_r_5">*</i><abbr>请选择需要退回的文章：</abbr></span>
        <abbr style="width: 150px" class="d_i">
          <allSelect :multiple="true" :chooseData="contentList" :needReturn="'id'" :placeholder="'请选择需要退回的文章'" :matchValue="'title'" :showValue="'{{title}}'" v-model="returnIds">
          </allSelect>
        </abbr>
      </div>
    </model>
  </div>
</template>

<script>
 // tip 信息安全原因，不能直接导出hcp
// import axios from 'axios'
export default {
  name: 'ContentRelease',
  data () {
    return {
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      addnewContentType: '3',
      onSearch: false,
      coverShow: false,
      returnIds: '',
      newModel: false,
      newModel2: false,
      contentList: [],
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      myList: [],
      isAdmin: window.localStorage.getItem('isAdmin'),
      postData: {
        pushStatus: '0',
        msgPublishId: '',
        contentTitle: '',
        ContentTypeIds: '',
        startMsgPublishModifiedTime: '',
        endMsgPublishModifiedTime: '',
        contentCreatorUser: '',
        messageStates: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      pushStatusList: [
        {
          id: '0',
          typeName: '请选择状态'
        },
        {
          id: '1',
          typeName: '待推送'
        },
        {
          id: '2',
          typeName: '已推送'
        },
        {
          id: '3',
          typeName: '审核中'
        },
        {
          id: '4',
          typeName: '审核失败'
        }
      ],
      pushTypeList: [
        {
          pushType: '1',
          name: '文本'
        },
        {
          pushType: '2',
          name: '图片'
        },
        {
          pushType: '3',
          name: '图文消息'
        }
      ],
      allcontent: JSON.parse(window.sessionStorage.getItem('allContentType')),
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')),
      messageStateList: []
    }
  },
  created () {
    // this.getconTypeList()
    // this.getMessageStatus()
    // this.getconTypeList2()
    this.getList(1)
  },
  methods: {
    successList (item) {
      this.$commonJs.doubleComfirm({
        content: '是否确定审核通过？',
        successFun: msg => {
          this.$axiox.post('/api/push/audiet/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '审核通过',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    failList (item) {
      this.$axiox.get('/api/push/query/' + item.id).then(msg => {
        this.failItem = msg
        console.log(item)
        this.newModel2 = true
        this.getAllContent(this.failItem)
      })
    },
    async getAllContent (p) {
      this.contentList = []
      for (let i = 0; i < p.pushArticle.length; i++) {
        let contentde = await this.$axiox.asyncGet('/api/Article/' + p.pushArticle[i])
        console.log(contentde)
        if (contentde.content.indexOf('<video') >= 0) {
          this.contentList.push(contentde)
        }
        // let data = {
        //   url: p.messageContentMappings[i].url,
        //   detailInfo: p.messageContentMappings[i].content
        // }
      }
    },
    deletePush (object) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此推送？',
        successFun: msg => {
          this.$axiox.get('/api/push/del/' + object.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    // tip 信息安全原因，不能直接导出hcp
    // exportPushPeople (id) {
    //   axios.get(`/api/push/ExportPushPeople?id=${id}`, {responseType: "arraybuffer"})
    //   .then(res => {
    //     console.log(res, 'exportList')
    //     const data = res.data
    //     const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
    //     const link = document.createElement('a')
    //     link.style.display = 'none'
    //     link.href = url
    //     link.setAttribute('download', '接收人列表.xlsx')
    //     document.body.appendChild(link)
    //     link.click()
    //     document.body.removeChild(link)
    //   }).catch(err => {
    //     console.log(err, 'err')
    //   })
    // },
    clearModel () {
      this.postData = {
        msgPublishId: '',
        contentTitle: '',
        ContentTypeIds: '',
        startMsgPublishModifiedTime: '',
        endMsgPublishModifiedTime: '',
        contentCreatorUser: '',
        messageStates: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      }
    },
    // returnContentId (type) {
    //   switch (type) {
    //     case 10:
    //       return '新建'
    //     case 20:
    //       return '待审批（内容管理员）'
    //     case 30:
    //       return '待审批（组管理员）'
    //     case 31:
    //       return '已拒绝'
    //     case 50:
    //       return '待发布'
    //     case 60:
    //       return '定时发布'
    //     case 70:
    //       return '已发布'
    //   }
    //   return ''
    // },
    getMessageStatus () {
      this.$axiox.getNomalData('/api/application/api/content/messageState').then(msg => {
        this.messageStateList = JSON.parse(JSON.stringify(msg))
      })
    },
    // getconTypeList (pageIndex) {
    //   this.postData.pageIndex = pageIndex
    //   let url = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
    //   this.$axiox.get(url).then(msg => {
    //     this.allcontent = JSON.parse(JSON.stringify(msg.result.items))
    //     // this.allcontent2 = JSON.parse(JSON.stringify(msg.result.items))
    //   })
    // },
    // getconTypeList2 () {
    //   this.$axiox.get('/api/contentType/fromuser/' + JSON.parse(this.userInfo.id)).then(msg => {
    //     let editorTypes = JSON.parse(JSON.stringify(msg.result.editorTypes))
    //     let ownerTypes = JSON.parse(JSON.stringify(msg.result.ownerTypes))
    //     this.allcontent2 = this.$commonJs.distinct(editorTypes, ownerTypes)
    //   })
    // },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl () {
      this.newModel = true
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.start === '') {
        delete data['start']
      }
      if (data.end === '') {
        delete data['end']
      }
      if (parseInt(data.pushStatus) === 0) {
        delete data['pushStatus']
      } else {
        data.pushStatus = parseInt(data.pushStatus)
      }
      if (data.start) {
        data.start += ' 00:00:00'
      }
      if (data.end) {
        data.end += ' 23:59:59'
      }
      let url = this.$commonJs.returnQuery('/api/push/query', data)
      this.$axiox.getList(url).then(msg => {
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    editList () {
      this.$router.push({
        name: 'ContentReleaseList'
      })
    },
    confirModel2 () {
      let data = {
        pushid: this.failItem.id,
        articleIDs: []
      }
      if (this.returnIds) {
        let list = this.returnIds.split(',')
        for (let i = 0; i < list.length; i++) {
          data.articleIDs.push(parseInt(list[i]))
        }
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请至少选择一篇文章',
          stayTime: 5
        })
        return
      }
      this.$axiox.post('/api/push/fail/' + this.failItem.id, data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '退回成功',
          stayTime: 5
        })
        this.newModel2 = false
        this.getList(1)
      })
    },
    confirModel () {
      if (this.addnewContentType !== '') {
        this.$router.push({
          name: 'ContentReleaseList',
          query: {
            id: 0,
            pushType: this.addnewContentType
          }
        })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择内容类别!',
          stayTime: 5
        })
      }
    },
    cancelModel () {
      this.newModel = false
      this.newModel2 = false
      this.addnewContentType = ''
    },
    todetail (item) {
      let pushType = 1
      if (item.pushtype === '图片消息') {
        pushType = 2
      }
      if (item.pushtype === '图文消息') {
        pushType = 3
      }
      this.$router.push({
        name: 'ContentReleaseList',
        query: {
          id: item.id,
          messageState: item.pushStatus,
          pushType: pushType
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/ContentRelease.vue